<template>
  <v-dialog v-model="dialog" max-width="860">
      <template #activator="{on}">
          <v-btn
            :disabled="!canMarkAsShipped"
            color="accent"
            v-on="on"
            >Mark as sent</v-btn
            >
      </template>
      <v-card :disabled="loading" :loading="loading">
        <v-form ref="orderClose" v-model="valid" lazy-validation>
          <v-card-title class="headline grey lighten-2" primary-title
            >Mark as Shipped</v-card-title
          >
          <v-card-text>
            <v-text-field
              v-model="orderCloseForm.tracking"
              :rules="mandatoryRules"
              label="Tracking Code"
            ></v-text-field>
            <v-textarea
              v-model="orderCloseForm.comment"
              label="Your comment"
              hint="Please leave a comment if necessary"
            ></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="accent" @click="submit()"
              >Mark as shipped</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
  </v-dialog>
</template>

<script>
import ORDER_STATUS from "@/utils/order.status.js";
import { mapActions, mapGetters } from 'vuex';

export default {
    data: () => ({
      dialog:false,
      valid: null,
      orderCloseForm: {
        comment: null,
        tracking: null,
        form: false,
      },
      mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
    }),
    props:{
        handling:{
            type: Object,
            required: true,
        },
        order:{
          type:Object,
          required:true
        }
    },
    computed:{
      ...mapGetters('handling', ['loading']),
        canMarkAsShipped: function() {
            if(this.handling.status_id != "shipped" && ORDER_STATUS.isOpen(this.order.statusId)){
              return true;
            }
            return false
        },
    },
    methods:{
        ...mapActions("handling", {markAsShipped: "markAsShipped"}),
        submit() {
            if (this.$refs.orderClose.validate()) {
                this.markAsShipped({
                    id: this.handling.id,
                    trackingId: this.orderCloseForm.tracking,
                    comment: this.orderCloseForm.comment,
                })
                .then(({success}) => {
                    if (success) {
                        this.$emit("refresh")
                        this.dialog=false
                    }
                });
            }
        },
    }
}
</script>

<style>
</style>